import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { EmpresaVO } from '../shared/model';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  private readonly endpoint = '/sepin-backend/rest/empresas';
  private readonly endpointIdentifica = '/sepin-backend/rest/identificacao-preenchimentos';

  constructor(private readonly http: McticHttpClient,
    private readonly securityService: SecurityService) {
  }

  obterEmpresaSelecionada(idPessoaJuridicoUnico: number, idAnoBase: number): Observable<EmpresaVO> {
    return this.http.get<EmpresaVO>
      (`${this.endpoint}/id-unico/${idPessoaJuridicoUnico}/ano-base/${idAnoBase}`);
  }

  obterEmpresasRdaAutenticado(): Observable<EmpresaVO[]> {
    return this.http.get<EmpresaVO[]>(`${this.endpoint}/rda-autenticado`);
  }

  indicarEmpresaResponsavel(empresa: EmpresaVO) {
    return this.http.post(this.endpointIdentifica, empresa);
  }

  alterarEmpresaResponsavel(empresa: EmpresaVO) {
    return this.http.put(this.endpointIdentifica, empresa);
  }

  atualizar(empresa: EmpresaVO) {
    return this.http.put(this.endpoint, empresa);
  }

  obterEmpresaRdaCartaCredito(): Observable<EmpresaVO[]> {
      return this.http.get<EmpresaVO[]>(`${this.endpoint}/rda-carta-credito`);
  }

  isEmpresaIncentivada(): boolean {
    const usuarioSessao = this.securityService.usuarioSessao;
    return this.securityService.isEmpresaAutenticada() && usuarioSessao.rdaAutenticado.incentivada;
  }

  isEmpresaContratante(): boolean {
    const usuarioSessao = this.securityService.usuarioSessao;
    return this.securityService.isEmpresaAutenticada() &&
      usuarioSessao.rdaAutenticado.contratante &&
      !usuarioSessao.rdaAutenticado.incentivada
  }

  isEmpresaPadis(): boolean {
    const usuarioSessao = this.securityService.usuarioSessao;
    return this.securityService.isEmpresaAutenticada() &&
      !usuarioSessao.rdaAutenticado.incentivada &&
      !usuarioSessao.rdaAutenticado.contratante &&
      usuarioSessao.rdaAutenticado.padis
  }

  atualiazarEmpresaAutenticado(idAnoBase: number): Observable<EmpresaVO> {
    const empresaAutenticada = this.obterEmpresaAutenticada();
    return this.obterEmpresaSelecionada(empresaAutenticada.idUnicoPessoaJuridica, idAnoBase)
      .pipe(
        map((empresaVO: EmpresaVO) => {
          this.securityService.atualiazarEmpresaAutenticadoToken(empresaVO);
          return empresaVO;
        })
      )
  }

  obterEmpresaAutenticada(): EmpresaVO {
    const usuarioSessao = this.securityService.usuarioSessao;
    return usuarioSessao.empresa;
  }

}
